import { z } from 'zod';
import { requestIdSchema, timestampSchema, apiResponseType, messageTemplateType, providerType, } from '@repo/shared/types';
var MESSAGE_SEND_TYPE = apiResponseType.refine(function (type) { return type === 'MESSAGE_SEND'; });
var MESSAGE_TEMPLATE_TYPE = messageTemplateType.refine(function (type) { return type === 'CONTACT_FORM'; });
// Request
export var messageSendRequestBodySchema = z.object({
    requestId: requestIdSchema,
    type: MESSAGE_SEND_TYPE,
    provider: providerType,
    template: MESSAGE_TEMPLATE_TYPE,
    message: z.string(),
});
// Response code 202
export var messageSendSuccessResponseBodySchema = z.object({
    requestId: requestIdSchema,
    timestamp: timestampSchema,
    type: MESSAGE_SEND_TYPE,
    data: z.object({
        messageId: z.string(),
    }),
});
// Response code 400
export var messageSendIncorrectValueResponseBodySchema = z.object({
    requestId: requestIdSchema,
    timestamp: timestampSchema,
    type: MESSAGE_SEND_TYPE,
    data: z.object({
        parameter: z.string(),
        // eslint-disable-next-line camelcase
        error_description: z.string(),
    }),
});
// Response code 404 - Agreement for provider exists
export var messageSendNotFoundResponseBodySchema = z.object({
    requestId: requestIdSchema,
    timestamp: timestampSchema,
    type: MESSAGE_SEND_TYPE,
    data: z.object({
        parameter: z.string(),
        // eslint-disable-next-line camelcase
        error_description: z.string(),
    }),
});
// Response code 500 - Unexpected exception
export var messageSendInternalServerErrorResponseBodySchema = z.object({
    requestId: requestIdSchema,
    timestamp: timestampSchema,
    type: MESSAGE_SEND_TYPE,
    data: z.object({
        // eslint-disable-next-line camelcase
        error_description: z.string(),
    }),
});
